import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SalesTransactionExportCriteria } from '../models/report.model';
import { metricsReporting } from '../utils/metrics-util';
import { BaseService } from './base.service';

@Injectable()
export class SalesTransactionConfidentialReportService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.salesTransactionConfidentialReport;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  reportExport(reportCriteria: SalesTransactionExportCriteria) {
    const url = this.getFullUrl(this.envService.export);
    const metrics = metricsReporting([this.envService.url, this.envService.export]);

    return this.http.post<any>(url, reportCriteria, {
      headers: this.loaderHeaders(0, metrics),
      observe: 'body'
    });
  }
}
